import React from 'react';
import {
	Router,
	Route,
	Switch,
	Link
} from 'react-router-dom';

import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Axios from 'axios';
import moment from 'moment';

// Router: Accueil
import Admin_HomeTab from './Admin_HomeTab';

// Router: Pointages
import ScoresheetsNav from './scoresheet/ScoresheetsNav';

// Router: Ligue
import LeagueAdmin from './leagues/LeagueAdmin';
import AddSeason from './leagues/AddSeason';

// Router: Saison
import SeasonAdmin_gen from './leagues/SeasonAdmin_gen';
import SeasonAdmin_eqcfg from './leagues/SeasonAdmin_eqcfg';
import SeasonAdmin_qvneaSummary from './leagues/SeasonAdmin_qvneaSummary';
import SeasonAdmin_subs from './leagues/SeasonAdmin_subs';
import AddSubseason from './leagues/AddSubseason';
import SubseasonAdmin from './leagues/SubseasonAdmin';

// Router Customers
import RateSysAdminParams from './customers/RateSysAdminParams';
import RateSysAdminResults from './customers/RateSysAdminResults';
import RateSysAdminList from './customers/RateSysAdminList';

import SeasonSchedule from './leagues/SeasonSchedule';

// App
import * as myConstClass from '../shared/constants/constants';
import Users from '../users/Users';

import LeaguesDropdown from '../shared/LeaguesDropdown';
import SeasonsDropdown from '../shared/SeasonsDropdown';

// Refs:  React router and tabs
// https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// https://github.com/reactstrap/reactstrap/issues/298
// https://codesandbox.io/s/github/browniefed/tmp/tree/reactRouterDynamicRoutes/?from-embed
// https://stackoverflow.com/questions/51203888/reactjs-routing-to-different-tabs

// ADMIN MAINTENANCE SPECIAL CONSTANT
const ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER = false;

const ADMIN_LVL_MASTER = 0;
const ADMIN_LVL_CHARTERS = 1;
const ADMIN_LVL_LEAGUES = 2;
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;
const ADMIN_LVL_ADMINLIMIT = 20;
const ADMIN_LVL_NOACCESS = 99;

class AdminSaisons extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			activeTabItem: '1',

			isAuthenticated: this.props.auth.isAuthenticated(),
			profile: this.props.auth.getProfile(),
			adminAccess: {
				auth: this.props.auth,
				globalAccessLevel: ADMIN_LVL_NOACCESS,
				adminValidatedAccessLevel: ADMIN_LVL_NOACCESS,
				charterAdmin: ''
			},

			leagues: [],
			leagueId: "",
			league: {},
			seasons: [],
			seasonId: "0",
			season: {},

			bRateSysExists: false
		};
	
		this.toggle = this.toggle.bind(this);
		this.loadLeagues = this.loadLeagues.bind(this);
		this.loadSeasons = this.loadSeasons.bind(this);
		this.loadSeason = this.loadSeason.bind(this);
		this.reloadSeason = this.reloadSeason.bind(this);
		this.leagueChange = this.leagueChange.bind(this);
		this.seasonChange = this.seasonChange.bind(this);
		this.getAdminRightsInfo = this.getAdminRightsInfo.bind(this);
	}

	componentDidMount() {
		//console.log('ADMIN_SEASONS: componentDidMount');
		//console.log(this.props)
		this.loadLeagues();
	}

	UNSAFE_componentWillReceiveProps(nextprops) {
		// console.log('ADMIN_SEASONS: UNSAFE_componentWillReceiveProps');
	}

	toggle(tab) {
		if (this.state.activeTabItem !== tab) {
			this.setState({
				activeTabItem: tab
			});
		}
	}

	render() {
		//console.log('Admin_Seasons: render');
		//console.log('this.state.adminAccess.globalAccessLevel: ' + this.state.adminAccess.globalAccessLevel);
		//console.log('this.state.adminAccess.adminValidatedAccessLevel: ' + this.state.adminAccess.adminValidatedAccessLevel);

		// console.log('Admin_Seasons this.props')
		// console.log(this.props)

		var bAdminLvl = this.state.adminAccess.globalAccessLevel;
		var bRateSysExists = this.state.bRateSysExists;
		var bEnableSheduledPrograms = 
			(this.state.season.liveScoresheets === "PRÉPARATION") || 
			(this.state.season.liveScoresheets === "ACTIVÉES");

		//bAdminLvl = 10;	// force for tests

		return (
			<div>

				{/* ----------------- LIGUE & SAISON selectors ---------------- */}
				<div className="row row-align-items-flex-end">
					<div className="col-md-6 col-12">
					<div className="card card-accent-success">
					<div className="card-header">
						<i className="fa fa-th-large"></i>Ligue et Saison
					</div>

					<div className="card-block">
						Sélectionner une Ligue
						<LeaguesDropdown value={this.state.leagueId} leagues={this.state.leagues} 
							leagueChange={this.leagueChange} bOption0={false}></LeaguesDropdown>
							<br/>

						Sélectionner une Saison
						<SeasonsDropdown value={this.state.seasonId} seasons={this.state.seasons} 
							seasonChange={this.seasonChange}></SeasonsDropdown>
					</div>
					</div>
					</div>

					<div className="col-md-6 col-12 row-margin-bottom-20">
						<p>* Pour une utilisation optimale de Statelo en mode Administrateur, utiliser le navigateur Google Chrome que vous pouvez télécharger ici</p>
	        	<a href={'https://www.google.fr/intl/fr/chrome/'} target="_blank">
			        <input type="button" className="btn btn-primary btn-sm db-menu-padsides" value="Télécharger Google Chrome" />
	        	</a>
					</div>
				</div>

				{/* ----------------- TAB CONTAINER ---------------- */}
				<div className="row">
					<div className="col-md-12">
					<div className="card card-accent-success">
					<div className="card-block">
					<Nav tabs>

						{(bAdminLvl <= ADMIN_LVL_SEASONS) && <NavItem>
							<NavLink tag={Link} to="/admsafe/home" 
								active={this.state.activeTabItem === '1'}
								onClick={() => { this.toggle('1'); }}>
								Accueil
							</NavLink>
						</NavItem>}

						{/* Scoresheets-access */}
						{(bAdminLvl <= ADMIN_LVL_SCORESHEETS) && <NavItem>
							<NavLink tag={Link} to="/admsafe/ssnav"
								active={this.state.activeTabItem === '2'}
								onClick={() => { this.toggle('2'); }}>
								Pointages
							</NavLink>                        
						</NavItem>}

						{(bAdminLvl <= ADMIN_LVL_LEAGUES) && <NavItem>
							<NavLink tag={Link} to="/admsafe/league"
								active={this.state.activeTabItem === '3'}
								onClick={() => { this.toggle('3'); }}>
								Ligue
							</NavLink>                        
						</NavItem>}

						{(bAdminLvl <= ADMIN_LVL_SEASONS) && <NavItem>
							<NavLink tag={Link} to="/admsafe/season"
								active={this.state.activeTabItem === '4'}
								onClick={() => { this.toggle('4'); }}>
								Saison
							</NavLink>                        
						</NavItem>}

						{/* Scoresheets-access: Same as seasons but limited to team config only */}
						{(bAdminLvl === ADMIN_LVL_SCORESHEETS) && <NavItem>
							<NavLink tag={Link} to="/admsafe/season/eqcfg"
								active={this.state.activeTabItem === '5'}
								onClick={() => { this.toggle('5'); }}>
								Équipes
							</NavLink>                        
						</NavItem>}
						
						{(bAdminLvl <= ADMIN_LVL_SEASONS) && bRateSysExists && <NavItem>
							<NavLink tag={Link} to="/admsafe/rateSys"
								active={this.state.activeTabItem === '6'}
								onClick={() => { this.toggle('6'); }}>
								Cotation
							</NavLink>                        
						</NavItem>}

						{(bAdminLvl <= ADMIN_LVL_SEASONS) && bEnableSheduledPrograms && <NavItem>
							<NavLink tag={Link} to="/admsafe/schedule"
								active={this.state.activeTabItem === '7'}
								onClick={() => { this.toggle('7'); }}>
								Programmes
							</NavLink>                        
						</NavItem>}

					</Nav>

					{/* ----------------- TAB CONTENT - ROUTER ---------------- */}
					<TabContent activeTab="1">
					<TabPane tabId="1">
						<Switch>
							{/* Routes: Accueil */}
							<Route path="/admsafe/home" render={(props) => <Admin_HomeTab
								adminAccess={this.state.adminAccess} season={this.state.season} />} />

							{/* Routes: Pointages */}
							<Route path="/admsafe/ssnav" render={(props) => 
								<ScoresheetsNav adminAccess={this.state.adminAccess} season={this.state.season} />} />

							{/* Routes: Ligue */}
							<Route path="/admsafe/league" exact render={(props) => 
								<LeagueAdmin adminAccess={this.state.adminAccess} league={this.state.league} 
									seasons={this.state.seasons} reloadLeagues={this.loadLeagues} />} />

							<Route path="/admsafe/leagues/:lgid/seasons/add" render={(props) => 
								<AddSeason history={this.props.history} reloadLeagues={this.loadLeagues} 
									lgid={props.match.params.lgid} />} />

							{/* Routes: Saison */}
							<Route exact path="/admsafe/season" render={(props) => 
								<SeasonAdmin_gen 
									adminAccess={this.state.adminAccess} 
									season={this.state.season}
									reloadSeason={this.reloadSeason} />} />

							<Route path="/admsafe/season/eqcfg" render={(props) => 
								<SeasonAdmin_eqcfg 
									adminAccess={this.state.adminAccess} 
									season={this.state.season} 
									profile={this.state.profile} />} />

							<Route path="/admsafe/season/qvneaSummary" render={(props) => 
								<SeasonAdmin_qvneaSummary 
									adminAccess={this.state.adminAccess} 
									profile={this.state.profile}
									season={this.state.season} />} />

							<Route path="/admsafe/season/subs" render={(props) => 
								<SeasonAdmin_subs 
									history={this.props.history}
									adminAccess={this.state.adminAccess} 
									season={this.state.season} />} />

							<Route path="/admsafe/subseason/add/:ssid" render={(props) => 
								<AddSubseason 
									history={this.props.history}
									seasonId={this.state.season._id}
									ssid={props.match.params.ssid}
									reloadSeason={this.reloadSeason} />} />

							<Route path="/admsafe/subseason/:ssid" render={(props) => 
								<SubseasonAdmin 
									season={this.state.season}
									ssid={props.match.params.ssid}
									reloadSeason={this.reloadSeason} />} />

							<Route exact path="/admsafe/rateSys" render={(props) => 
								<RateSysAdminParams 
									history={this.props.history} 
									adminAccess={this.state.adminAccess} 
									season={this.state.season} 
									bRateSysExists={bRateSysExists} />} />

							<Route path="/admsafe/rateSys/results" render={(props) => 
								<RateSysAdminResults
									history={this.props.history} 
									adminAccess={this.state.adminAccess} 
									season={this.state.season} 
									bRateSysExists={bRateSysExists} />} />

							<Route path="/admsafe/rateSys/list" render={(props) => 
								<RateSysAdminList
									history={this.props.history} 
									adminAccess={this.state.adminAccess} 
									season={this.state.season} 
									bRateSysExists={bRateSysExists} />} />

							<Route exact path="/admsafe/schedule" render={(props) => 
								<SeasonSchedule 
									history={this.props.history} 
									adminAccess={this.state.adminAccess} 
									season={this.state.season}
									bEnableSheduledPrograms={bEnableSheduledPrograms} />} />

						</Switch>
					</TabPane>
					</TabContent>
				</div>
				</div> 
				</div>
				</div>
				<br/>
			</div>
		)
	}

	// ***********************************************************************************
	// LEAGUES
	// ***********************************************************************************
	loadLeagues() {
		// console.log('Admin: loadLeagues');

		var _this = this;
		var leagueId = this.state.leagueId;
		Axios.get('/api/leagues/authUserId/' + this.state.profile.user_id).then(function(response) {
		
			var leagues = response.data;
			var league = "";

			// Pick first by default, if no leagueId is set
			if(leagues.length !== 0) {
				if (leagueId !== "") {
					leagues.forEach(function(leagueItem) {
						if(leagueItem._id === leagueId) {
							league = leagueItem;
						}
					});
				}
				else {
					leagueId = leagues[0]._id;
					league = leagues[0];
				}

				_this.loadSeasons(leagues, leagueId, league);
			}
		});
	}

	leagueChange(leagueId) {
		// console.log('Admin: leagueChange');
		// console.log(leagueId);

		var league = {};
		var leagues = this.state.leagues;
		leagues.forEach(function(leagueItem) {
			if(leagueItem._id === leagueId) {
				league = leagueItem;
			}
		});

		this.loadSeasons(leagues, leagueId, league);
	}

	seasonChange(seasonId) {
		// console.log('Admin: seasonChange');
		// console.log(seasonId);
		this.loadSeason(this.state.leagueId, seasonId);
	}

	// ***********************************************************************************
	// Seasons, Scoresheets, ScoresheetFormat, Data
	// ***********************************************************************************
	loadSeasons(leagues, leagueId, league) {
		// console.log('Admin: loadSeasons');
		var _this = this;
		var seasonId = "0";

		// Get Seasons Table for this leagueId
		Axios.get('/api/seasons/leagueId/' + leagueId + '/authUserId/' + this.state.profile.user_id).then(function(response) {
			var seasons = response.data;
			// seasons.sort((a, b) => {(a.name.localeCompare(b.name))});

			// Default season id the first on list
			if(seasons.length !== 0) {
				seasonId = seasons[seasons.length - 1]._id;  // pick first
			}

			// don't load here, since multiple setStats causes errors in ScoresheetsList axios.get
			//_this.loadSeason(leagueId, seasonId);
			if (seasonId !== "0") {

				Axios.get('/api/seasons/' + seasonId).then(function(response) {
				Axios.get('/api/ratesys/rateSysExisting/' + seasonId).then(function(responseRatesys) {

					var season = response.data.season;
					if(season.standingTypeTeams === null) {
						season.standingTypeTeams = 0;
					}
					if(season.standingTypePlayers === null) {
						season.standingTypePlayers = 0;
					}
					season.dateStart = moment(season.dateStart).utc().format('YYYY-MM-DD');
					season.dateEnd = moment(season.dateEnd).utc().format('YYYY-MM-DD');

					// console.log('Admin: setState: loadSeason');
					_this.setState({
						leagues: leagues,
						leagueId: leagueId,
						league: league,
						seasons: seasons,
						seasonId: seasonId,
						season: season,
						bRateSysExists: responseRatesys.data.exists
					});
					_this.getAdminRightsInfo(leagueId, seasonId);
				});
				});

			} else {
				// ### DEBUG ###
				// console.warn("DEBUG HERE: REMOVE!");
				// seasonId = "6308ca58b8dc73325e70ccd0";
				_this.setState({
					leagues: leagues,
					leagueId: leagueId,
					league: league,
					seasons: seasons,
					seasonId: seasonId,
					season: {},                 // test
				});                
				_this.getAdminRightsInfo(leagueId, seasonId);
			}
		});
	}

	reloadSeason() {
		// console.log('Admin: reloadSeason');
		this.loadSeason(this.state.leagueId, this.state.seasonId);
	}

	loadSeason(leagueId, seasonId) {
		//console.log('Admin: loadSeason');
		//console.log(seasonId);

		if (seasonId !== "0") {
			var _this = this;
			Axios.get('/api/seasons/' + seasonId).then(function(response) {
			Axios.get('/api/ratesys/rateSysExisting/' + seasonId).then(function(responseRatesys) {

				var season = response.data.season;
				if(season.standingTypeTeams === null) {
					season.standingTypeTeams = 0;
				}
				if(season.standingTypePlayers === null) {
					season.standingTypePlayers = 0;
				}
				season.dateStart = moment(season.dateStart).utc().format('YYYY-MM-DD');
				season.dateEnd = moment(season.dateEnd).utc().format('YYYY-MM-DD');

				// console.log('Admin: setState: loadSeason');
				_this.setState({
					seasonId: seasonId,
					season: season,
					bRateSysExists: responseRatesys.data.exists
				});

				_this.getAdminRightsInfo(leagueId, seasonId);
			});
			});
		}
	}

	getAdminRightsInfo(leagueId, seasonId) {

		// console.log('Admin: getAdminRightsInfo');
		var _this = this;
		var charterId = 0;  // temp
		var adminAccess = this.state.adminAccess;

		if (this.state.isAuthenticated) {
			Users.getAccessLevel(_this.state.profile, function(globalAccessLevel) {
			Users.getValidateAccessLevel(_this.state.profile, charterId, leagueId, seasonId, function(validatedAccessLevel) {
			Users.getCharterAdmin(_this.state.profile, function(charterAdmin) {

				// console.log('Admin: setState: getAdminRightsInfo');
				// console.log(adminAccess);
				adminAccess.globalAccessLevel = globalAccessLevel;
				adminAccess.adminValidatedAccessLevel = validatedAccessLevel;
				adminAccess.charterAdmin = charterAdmin;

				_this.setState({
					adminAccess: adminAccess
				});

				// push landing admin page if Scoresheets Only admin
				if (adminAccess.adminValidatedAccessLevel === ADMIN_LVL_SCORESHEETS) {
					_this.setState({ activeTabItem: '2' });
					_this.props.history.push('/admsafe/ssnav');
				}
		
			});
			});
			});

		} else {
			adminAccess.globalAccessLevel = ADMIN_LVL_NOACCESS;
			adminAccess.adminValidatedAccessLevel = ADMIN_LVL_NOACCESS;
			adminAccess.charterAdmin = '';
			this.setState({
				adminAccess: adminAccess
			});
		}
	}

};

export default AdminSaisons;
